import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { Card } from './styles';
import { projectService } from '../../../services/projectService';

const CardButton = ({ image, project_id, card_name }) => {
  const [isSelected, setIsSelected] = useState(false);

  const sdgMapping = {
    'erradicao-pobreza': 'no_poverty',
    'fome-zero': 'zero_hunger',
    'saude-bem-estar': 'good_health',
    'educacao-qualidade': 'quality_education',
    'igualdade-genero': 'gender_equality',
    'agua-potavel-saneamento': 'clean_water',
    'energia-limpa': 'affordable_energy',
    'trabalho-decente': 'decent_work',
    'industria-inovacao': 'industry_innovation',
    'reducao-desigualdade': 'reduced_inequalities',
    'cidades-comunidades': 'sustainable_cities',
    'consumo-producao': 'responsible_consumption',
    'mudanca-do-clima': 'climate_action',
    'vida-na-agua': 'life_below_water',
    'vida-terrestre': 'life_on_land',
    'paz-justica': 'peace_justice',
    'parcerias': 'partnerships'
  };

  useEffect(() => {
    const fetchSelectedState = async () => {
      try {
        const token = sessionStorage.getItem('Authorization');

        // 🔹 1. Usa o service para buscar as ODS do projeto
        const odsResponse = await projectService.getAllSdgsByProject(project_id, token);

        const sdgsData = odsResponse.sdgs;
        const sdgField = sdgMapping[card_name];

        // 🔹 2. Verifica se a ODS correspondente está ativa
        if (sdgField && sdgsData[sdgField]?.value === true) {
          setIsSelected(true);
        } else {
          setIsSelected(false);
        }

      } catch (error) {
        console.error('❌ Erro ao buscar ODS:', error);
        Swal.fire({
          title: 'Erro!',
          text: 'Não foi possível verificar as ODS do projeto',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    };

    fetchSelectedState();
  }, [project_id, card_name]);


  return (
    <Card
      isSelected={isSelected}
    >
      <img id={card_name} src={image} alt={`ODS ${card_name}`} />
    </Card>
  );
};

export default CardButton;